import { httpMethods } from 'enums';
import { Http } from 'library';
import api from 'api/client';

import * as Endpoints from 'constants/endpoints.constant';
import {
  ADD_ACCOUNT,
  DOWNLOAD_SAMPLE_DOCS,
  GET_SAMPLE_DOCS,
} from 'constants/endpoints.constant';
import axios from 'axios';

class DashboardHttp {
  static getProfile = async (customerId: any, userId?: any) =>
    Http.setMethod(httpMethods.get)
      .setUrl(`${Endpoints.GET_PROFILE}/${customerId}?user_id=${userId}`)
      .setToken(api.getToken())
      .request();

  static updateBankDetails = async (data: any) =>
    Http.setMethod(httpMethods.patch)
      .setUrl(`${Endpoints.UPDATE_BANK_DETAILS}`)
      .setData(data)
      .setToken(api.getToken())
      .request();

  static updateUpiDetails = async (data: any) =>
    Http.setMethod(httpMethods.patch)
      .setUrl(`${Endpoints.UPDATE_UPI_DETAILS}`)
      .setData(data)
      .setToken(api.getToken())
      .request();

  static createAccount = async (data: any, userId: any) => {
    const newData = { ...data, user_id: userId };
    return Http.setMethod(httpMethods.post)
      .setUrl(`${Endpoints.ADD_ACCOUNT}`)
      .setData(newData)
      .setToken(api.getToken())
      .request();
  };

  /**
   * Create a B2B GST Sub-account
   * @param data Request Payload
   * @returns API Response
   */
  static createGstAccount = async (data: any) =>
    Http.setMethod(httpMethods.post)
      .setUrl(`${Endpoints.ADD_GST_ACCOUNT}`)
      .setData(data)
      .setToken(api.getToken())
      .request();

  /**
   * Create a B2B Non-GST Sub-account
   * @param data Request Payload
   * @returns API Response
   */
  static createNonGstAccount = async (data: any) =>
    Http.setMethod(httpMethods.post)
      .setUrl(`${Endpoints.ADD_NONGST_ACCOUNT}`)
      .setData(data)
      .setToken(api.getToken())
      .request();

  static getDocs = async (customerId: any) =>
    Http.setMethod(httpMethods.get)
      .setUrl(`${Endpoints.GET_CUSTOMER_DOCS}/${customerId}`)
      .setToken(api.getToken())
      .request();

  static uploadDoc = async (data: any) => {
    return await axios({
      method: 'post',
      url: process.env.REACT_APP_URL + Endpoints.UPLOAD_DOCS,
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + api.getToken(),
      },
    });
  };

  static deleteDoc = async (docId: any) =>
    Http.setMethod(httpMethods.delete)
      .setUrl(`${Endpoints.DELETE_DOC}/${docId}`)
      .setToken(api.getToken())
      .request();

  static searchBank = async (ifsc: any) => {
    return await axios({
      method: 'get',
      url: 'https://ifsc.razorpay.com/' + ifsc,
      headers: { 'Content-Type': 'application/json' },
    });
  };

  static accountVerify = async (data: any, userId: any) => {
    const newData = { ...data, user_id: userId };
    return Http.setMethod(httpMethods.post)
      .setUrl(`${Endpoints.ACCOUNT_VERIFY}`)
      .setData(newData)
      .setToken(api.getToken())
      .request();
  };

  static upiVerify = async (data: any) =>
    Http.setMethod(httpMethods.post)
      .setUrl(`${Endpoints.UPI_VERIFY}`)
      .setData(data)
      .setToken(api.getToken())
      .request();

  static getSampleDoc = async (id: any) =>
    Http.setMethod(httpMethods.get)
      .setUrl(`${Endpoints.GET_SAMPLE_DOCS}/${id}`)
      .setResponseType('application/json')
      .setToken(api.getToken())
      .request();

  static updateShippingAddress = async (id: any, data: any, userId: any) => {
    const newData = { ...data, user_id: userId };
    return Http.setMethod(httpMethods.patch)
      .setUrl(`${Endpoints.UPDATE_SHIPPING}/${id}`)
      .setData(newData)
      .setToken(api.getToken())
      .request();
  };

  static downloadSampleDoc = async (id: any) =>
    Http.setMethod(httpMethods.get)
      .setUrl(`${Endpoints.DOWNLOAD_SAMPLE_DOCS}/${id}`)
      .setResponseType('blob')
      .setToken(api.getToken())
      .request();

  // Customer Nomination APIs
  static addNominee = async (data: any) =>
    Http.setMethod(httpMethods.post)
      .setUrl(`${Endpoints.ADD_CUSTOMER_NOMINEE}`)
      .setData(data)
      .setToken(api.getToken())
      .request();

  static updateNominee = async (data: any, userId: any) => {
    const newdata = { ...data, user_id: userId };
    return Http.setMethod(httpMethods.patch)
      .setUrl(`${Endpoints.UPDATE_CUSTOMER_NOMINEE}`)
      .setData(newdata)
      .setToken(api.getToken())
      .request();
  };

  // Customer Consent verify
  static sendCustomerOtp = async (data: any) => {
    return Http.setMethod(httpMethods.post)
      .setUrl(`/sendotpCustomerMobile`)
      .setData(data)
      .setToken(api.getToken())
      .request();
  };

  static verifyCustomerOtp = async (data: any, userId: any) => {
    const newdata = { ...data, user_id: userId };
    return Http.setMethod(httpMethods.patch)
      .setUrl(`/verifyOtp-CustomerMobile`)
      .setData(newdata)
      .setToken(api.getToken())
      .request();
  };

  static resendCustomerOtp = async (data: any, userId: any) => {
    const newdata = { ...data, user_id: userId };
    return Http.setMethod(httpMethods.patch)
      .setUrl(`/resendOtp-CustomerMobile`)
      .setData(newdata)
      .setToken(api.getToken())
      .request();
  };

  static summaryReports = async (data: any) =>
    Http.setMethod(httpMethods.post)
      .unsetData()
      // .setUrl(`/account-statement-mail`)
      .setUrl(`${Endpoints.SUMMARY_REPORT}`)
      .setData(data)
      .setToken(api.getToken())
      .request();

  static capitalGain = async (data: any) =>
    Http.setMethod(httpMethods.post)
      .unsetData()
      // .setUrl(`/account-statement-mail`)
      .setUrl(`${Endpoints.CAPITAL_GAIN}`)
      .setData(data)
      .setToken(api.getToken())
      .request();

  // Nominee mobile verify
  static sendOtp = async (data: any, userId: any) => {
    const newdata = { ...data, user_id: userId };
    return Http.setMethod(httpMethods.post)
      .setUrl(`/sendotpAddNominee`)
      .setData(newdata)
      .setToken(api.getToken())
      .request();
  };

  static verifyOtp = async (data: any, userId: any) => {
    const newdata = { ...data, user_id: userId };
    return Http.setMethod(httpMethods.patch)
      .setUrl(`/verifyOtp-addNominee`)
      .setData(newdata)
      .setToken(api.getToken())
      .request();
  };

  // Income Source and Income Group
  static getIncomeGroup = async () => {
    return Http.setMethod(httpMethods.get)
      .setUrl(`/get/income-group`)
      .setToken(api.getToken())
      .request();
  };
  static getIncomeSource = async () => {
    return Http.setMethod(httpMethods.get)
      .setUrl(`/get/income-source`)
      .setToken(api.getToken())
      .request();
  };

  static getCustomerCreatedYear = async () => {
    return Http.setMethod(httpMethods.get)
      .setUrl(`/order/get-finacial-year`)
      .setToken(api.getToken())
      .request();
  };

  static updateProfileDetails = async (customerId: any, data: any) => {
    const newData = { ...data, customerId };
    return Http.setMethod(httpMethods.patch)
      .setUrl(`/customer/source/aadhar/update`)
      .setData(newData)
      .setToken(api.getToken())
      .request();
  };


  static resendOtp = async (data: any) => {
    return Http.setMethod(httpMethods.patch)
      .setUrl(`/resendOtp-addNominee`)
      .setData(data)
      .setToken(api.getToken())
      .request();

  };

  // Upload Bank Verification Document
  static uploadBankVerificationDoc = async (formData: FormData) => {
    return await axios({
      method: 'post',
      url: `${process.env.REACT_APP_URL}${Endpoints.UPLOAD_BANK_DOC}`,
      data: formData,
      headers: {
        Authorization: `Bearer ${api.getToken()}`,
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  // Get Bank Verification Documents
  static getBankVerificationDocs = async () => {
    return Http.setMethod(httpMethods.get)
      .setUrl(`/bank/verification/data`)
      .setToken(api.getToken())
      .request();
  };

  // Request Callback for Bank Verification
  static requestBankCallback = async (customerId: string) => {
    const data = { customerId };
    return Http.setMethod(httpMethods.get)
      .setUrl(`/bank/verification/callback`)
      .setData(data)
      .setToken(api.getToken())
      .request();
  };

};

export default DashboardHttp;
